module.exports = __webpack_public_path__ + "img/logo.7a3142f2.png";